export const ASSET_VER_STATUS = [
  { value: 'ACTIVE', color: '#27AE60' },
  { value: 'INACTIVE', color: '#EB5757' },
]
